import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';

import { useNavigate , useLocation } from 'react-router-dom';
import NavigationMenu from './NavigationMenu';
import ImageCarousel from './ImageCarousel';
import AppIcon from './AppIcon';
import styles from './Pronounce.module.css'

function Dashboard() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  var sideNavSize = 300;
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status
  const apps = [
    {
      logo: "images/poster.jpg",
      name: "SHOWCASE for TikTok",
      description: "Show off your TikToks on stream.",
      comingsoon: false,
      link: "/showcase",
    },
    {
      logo: "images/pronounce.webp",
      name: "Pronounce",
      description: "Own your pronouns with pride.",
      comingsoon: false,
      link: "/pronounce",
    },
    {
      logo: "images/showcasespotifuy.png",
      name: "SHOWCASE",
      description: "Notify your fans when you go live.",
      comingsoon: false,
      link: "/showcasespotify",
    },
    {
      logo: "images/poster.jpg",
      name: "GoLiveBot for Bluesky",
      description: "Notify your viewers.",
      comingsoon: false,
      link: "/golivebotbluesky",
    },
    {
      logo: "images/poster.jpg",
      name: "GoLiveBot",
      description: "Notify your fans when you go live.",
      comingsoon: false,
      link: "/showcase",
    },
    {
      logo: "images/poster.jpg",
      name: "Stream+Care",
      description: "Notify your fans when you go live.",
      comingsoon: false,
      link: "/showcase",
    },
  ];
  
  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      try {
        const link = 'https://super-stream.co/api/isSubscribed/' + localStorage.getItem("_id");

        const responseTest = await axios.get(link, {
          // Add any necessary headers or authentication tokens
        });

        // const response = await fetch(link, {
        //   method: 'GET',
        //   // Add any necessary headers or authentication tokens
        // });

        if (responseTest.status === 200) {
          setIsSubscribed(responseTest.data.data.isSubscribed);
        } else {
          // Handle error responses from the server
        }
      } catch (error) {
        // Handle network or fetch-related errors
      }
    };

    fetchSubscriptionStatus();
  }, []);

  useEffect(() => {
    function handleResize() {
      setIsCollapsed(window.innerWidth < (768 + sideNavSize));
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
    }, []);

  const location = useLocation();
  const user = location.state?.user;
  const navigate = useNavigate();

  const handleClickShowcase = () => {
    // Redirect the user to a different page
    navigate('/showcase');
  }

  const handleClickLogin = () => {
    // Redirect the user to a different page
    navigate('/login');
  }
  
  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const userId = localStorage.getItem("_id");
  return (
    <div className={`container-fluid`}>
      <div className="row">
          <div className="col">
            <div className="row">
              {isCollapsed ? null : (
                <div className={`col-2 nonScrollable ${isCollapsed ? `hideSidebar` : `showSidebar`}`}  style={{paddingRight: 0, paddingLeft: 0, width: sideNavSize + 'px', color: "#005293"}}>
                <div className="row" >
                  <div className={`col-12`} style={{backgroundColor: "#005293"}}>
                    <NavigationMenu />
                  </div>
                </div>
              </div>
              )}
                
                <div className={` col scrollable ${isCollapsed ? 'col-12' : ''}`} style={{ order: 1, background:'#193551' }}>
                    <div className="scrollableContent" >
                        <div className="App content-centered">  
                                <div className='row' > {/* this is to make a grid system within the app window */}
                                  <ImageCarousel />

                                </div>

                                <div style={{margin: '10px'}} className='row align-items-center'> {/* this is to make a grid system within the app window */}
                                <div className='col-md-9'>
                                <div className="contained" style={{ background: '#b3ddff' }}>
                                  <p style={{ margin: 0, paddingLeft: '15px', paddingRight: '15px', display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ fontWeight: 'bold' }}>Daily Streamer Tip:</span> Make the most of social media platforms like TikTok and post frequent stream clips! ⚡🌞💪
                                  </p>
                                </div>

                                </div>
                                <div style={{textAlign: 'center'}} className='col-md-3'>
                                <a href="/settings"><button  style={{width: "200px", margin: '10px'}}>Account</button></a>
                                </div>
                                </div> 
                                <div className="container-fluid">
                                <div className="row g-4"> {/* g-4 adds spacing between columns and rows */}
                                  {apps.map((app, index) => (
                                    <div
                                    key={index}
                                    className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                                    style={{ padding: "20px"}}
                                  >
                                    <a
                                      href={app.link || undefined} // Only set href if a link exists
                                      className="app-link"
                                      style={{
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        display: 'block',
                                        pointerEvents: app.link ? 'auto' : 'none', // Disable clicks if no link
                                        cursor: app.link ? 'pointer' : 'default', // Change cursor style
                                      }}
                                    >
                                      <AppIcon
                                        logo={app.logo}
                                        name={app.name}
                                        description={app.description}
                                        comingsoon={app.comingsoon}
                                      />
                                    </a>

                                  </div>                                  
                                  ))}
                                </div>
                                </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
)
}


export default Dashboard;